export interface IRoutes {
	index: string;
	career: string;
	contact: string;
	legalNotice: string;
}

export const routes: IRoutes = {
	index: "",
	career: 'career',
	contact: 'contact',
	legalNotice: 'legalNotice'
};
